import { PassengerGroupVersion } from '@skyscanner-internal/schemas-types/flights.pb';

import { getInfantAndChildCount } from './passengers';

import type { PassengerGroup as PassengerGroupSchema } from '@skyscanner-internal/schemas-types/flights.pb';
import type { SearchState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export type PassengerGroupO = PassengerGroupSchema;
export function PassengerGroup(userSearch: SearchState): PassengerGroupO {
  const { adults, child_ages } = userSearch;
  const childrenCount = getInfantAndChildCount(child_ages);
  return {
    groupModel: PassengerGroupVersion.ADULT_18_PLUS,
    adultCount: adults,
    childCount: childrenCount.childCount,
    infantCount: childrenCount.infantCount,
    nonAdultAges: child_ages,
  };
}
